import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'maxItems',
  standalone: false
})
export class MaxItemsPipe implements PipeTransform {
  /**
   * Transforms an array into a string in the format "item, item, item, and # more"
   *
   * @param value The array to transform
   * @param maxItems Maximum number of items to display before using "and # more"
   * @returns Formatted string
   */
  transform(value: string | string[], maxItems: number = 3): string {
    if (!value || !Array.isArray(value) || value.length === 0) {
      return value as string;
    }

    if (value.length <= maxItems) {
      return value.join(', ');
    }

    const items = value.slice(0, maxItems);
    const more = value.length - maxItems;

    return `${items.join(', ')}, and ${more} more`;
  }
}
